import { createAction } from '@reduxjs/toolkit';
import { IOrderCounter } from '../../../../dto';
import { ACT_SET, MN_ORDER_COUNTERS, TYPE_ELEMENT } from '../../../../common';

export const setOrderCounter = createAction<IOrderCounter>(
  `${MN_ORDER_COUNTERS}/${TYPE_ELEMENT}/${ACT_SET}`,
);
